import { packsClient } from "lib/clients";

export const persistUpdatedLayout = async (packId: string, updated, movedAssets): Promise<void> => {
  for (const item of movedAssets) {
    const payload: {
      group_id?: string;
      row_id?: string;
      order: number;
    } = {
      order: item.order,
    };

    payload.group_id = item?.group_id ? item.group_id : '';
    payload.row_id = item?.row_id ? item?.row_id : '';

    await packsClient.updateAsset(packId, item.id, payload);
  }

  return updated;
}
